<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center" prop="order_no" label="訂單號">
				</el-table-column>
				
				<el-table-column align="center"  prop="name"  label="姓名">
				</el-table-column>

                <el-table-column align="center" prop="money"  label="付款金額">
						<template slot-scope="scope">
							<span class="money_text">{{ scope.row.money }}</span>
						</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="phone"  label="聯絡電話">
				</el-table-column>
				
				<el-table-column align="center"  prop="address"  label="學生地址">
				</el-table-column>


				<el-table-column align="center"  prop="school_name"  label="學校名稱">
				</el-table-column>
				
				<el-table-column align="center"  prop="school_phone"  label="學校聯絡電話">
				</el-table-column>
				
				<el-table-column align="center"  prop="local"  label="學校地址">
				</el-table-column>

                <el-table-column align="center" prop="status"  label="訂單狀態">
						<template slot-scope="scope">
							<span class="text-success" v-if="scope.row.status==1">已付款</span>
							<span class="text-primary" v-if="scope.row.status==3">處理中</span>
							<span class="text-danger" v-if="scope.row.status==4">已發貨</span>
						</template>
				</el-table-column>
				
			</el-table>
		</div>


		<!-- <div style="height: 60px;"></div>
        <div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
	 -->
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
        props: {
            orderInfo: {
                type: Object,
                required: true
            },
        },
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					content:'',
					type:-1,
					all_type:-1,
					ins_type:-1,
					sendtype:-1,
					time: [],
				},
				model_title: 'Order',
				auth_val: 'Order',
				preUrl: "", //列表地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					sendtype:0,
					user_id:0,
					ins_id:0,
					ins_type:0,
					all_type:0,
					school_id:0,
					icon:'',
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				search:[],

			}
		},
        created() {
            this.preUrl = 'data/OrderPrizeList';
            this.search = this.orderInfo
			console.log(this.search)
			this.getList()
		},
		methods: {
		
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
		
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					content:'',
					type:-1,
					all_type:-1,
					ins_type:-1,
					sendtype:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
